// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getContact } from '@/contact/api/get-contact';
import { useSuspenseQuery } from '@tanstack/react-query';

export function useContact(contactKey: string) {
  const { data } = useSuspenseQuery({
    queryKey: ['contact', contactKey],
    queryFn: () => getContact(contactKey),
  });

  return { contact: data.contact };
}
